import { formatDate } from '@angular/common';

export function formatMonthName(locale: string, now: Date = new Date()): string {
  const name = formatDate(now, 'LLLL', locale, 'UTC');
  return name.charAt(0).toLocaleUpperCase(locale) + name.slice(1);
}
